import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../../features/admin/contact_us/slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const contact_us = useSelector((state) => state?.contact_us?.contact_us);

  console.log(contact_us, "contact_us");

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = contact_us?.current_page) => {
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: contact_us?.per_page,
      }),
    );
  };

  return {
    contact_us,
    name,
    setName,
    fetch,
  };
};
